import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getListings2 } from "../../../../../apis/listings/buyer";
import { ListingsInterface } from "../../../../../types";
import mockData from "../../../data.json";
import ListingCard from "../../../components/FeaturedProperty";

const FeaturedProperties = () => {
  const { features, popularCities } = mockData;
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const [listings, setListings] = useState<{
    isFetching: boolean;
    items: ListingsInterface[] | [];
  }>({
    isFetching: true,
    items: [],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      navigate(`/property-search/${searchText}`);
    }
  };

  useEffect(() => {
    const fetchListings = async () => {
      const response = await getListings2("?&sort_by=nwst&pt=building");
      setListings((prev) => ({
        ...prev,
        isFetching: false,
        items: response || [],
      }));
    };
    fetchListings();
  }, []);

  return (
    <div>
      <section className="px-4 sm:px-10 md:px-[72px] py-[30px]">
        <h2 className="section__title">Featured Properties</h2>
        <div className="flex justify-between flex-col md:flex-row gap-3 md:items-center">
          <p className="font-medium text-[16px] sm:text-[22px]">
            Prime properties you don’t want to miss
          </p>
          {!listings.isFetching && listings.items.length > 0 && (
            <Link to="/property-search">
              <button className="outline-button shadow-custom uppercase">
                Load more
              </button>
            </Link>
          )}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-[35px] mt-5 gap-y-[33px]">
          {!listings.isFetching &&
            (listings.items as any[])
              ?.slice()
              .sort((a, b) => {
                const dateA = new Date(a.approved_date).getTime();
                const dateB = new Date(b.approved_date).getTime();
                return dateB - dateA;
              })
              .slice(0, 3)
              .map((listing) => (
                <ListingCard key={listing.name} listing={listing} />
              ))}
          {!listings.isFetching && listings.items.length === 0 && (
            <span className="body-description !text-red-700">
              There are no listings yet
            </span>
          )}
        </div>
      </section>
    </div>
  );
};

export default FeaturedProperties;
